import { render, staticRenderFns } from "./SupplierInvoice.vue?vue&type=template&id=47c7beb2&scoped=true&"
import script from "./SupplierInvoice.vue?vue&type=script&lang=js&"
export * from "./SupplierInvoice.vue?vue&type=script&lang=js&"
import style0 from "./SupplierInvoice.vue?vue&type=style&index=0&id=47c7beb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c7beb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VList,VListItem,VMenu,VTooltip})
